<template>
    <div>
      <b-container fluid>
        <b-row class="mb-3">
          <b-col>
            <h2>{{ isEdit ? 'Editar Relatório Agrupado' : 'Criar Relatório Agrupado' }}</h2>
          </b-col>
        </b-row>

        <!-- Renderiza o componente atual da etapa -->
        <component
          :is="steps[stepIndex].component"
          :data="formData"
          @next="nextStep"
          @previous="previousStep"
          @update-data="updateData"
          @submit="submit"
          :is-edit="isEdit"
        />

        <b-row>
          <b-col>
            <b-alert :variant="feedback.type" dismissible :show="feedback.show" fade
              @dismissed="feedback.show=false">
                {{ feedback.data }}
            </b-alert>
          </b-col>
        </b-row>

        <!-- Controles de navegação -->
        <!-- <div class="navigation">
          <button
            v-if="stepIndex > 0"
            @click="previousStep"
          >
            Voltar
          </button>
          <button
            v-if="stepIndex < steps.length - 1"
            @click="nextStep"
          >
            Próximo
          </button>
          <button
            v-if="stepIndex === steps.length - 1"
            @click="submit"
          >
            {{ isEdit ? 'Salvar Alterações' : 'Concluir' }}
          </button>
        </div> -->
      </b-container>
    </div>
  </template>

  <script>
  // Importar os componentes das etapas
  import Step1 from './Step1.vue';
  import Step2 from './Step2.vue';
  import Step3 from './Step3.vue';

  export default {
    components: { Step1, Step2, Step3 },
    props: {
      // Determina se é edição ou criação
      isEdit: {
        type: Boolean,
        default: false,
      },
      // Dados do relatório (usado na edição)
      initialData: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        feedback: {
          show: false,
          type: 'success',
          data: '',
        },
        stepIndex: 0, // Etapa atual
        formData: { ...this.initialData }, // Inicializa com dados existentes ou vazio
        steps: [
          { title: 'Nome do Relatório', component: 'Step1' },
          { title: 'Seleção de Eventos', component: 'Step2' },
          { title: 'Gerenciamento de Usuários', component: 'Step3' },
        ],
      };
    },
    methods: {
      nextStep() {
        if (this.stepIndex < this.steps.length - 1) {
          this.stepIndex++;
        }
      },
      previousStep() {
        if (this.stepIndex > 0) {
          this.stepIndex--;
        }
      },
      updateData(newData) {
        // Atualiza os dados compartilhados entre as etapas
        this.formData = { ...this.formData, ...newData };
      },
      async submit() {
        if (this.isEdit) {
          // Lógica para enviar alterações para a API
          await this.updateGroupedReport()
          this.scrollToBottom()
          return
        }

        // Lógica para enviar novos dados para a API
        await this.createGroupedReport()
        this.scrollToBottom()
      },
      scrollToBottom() {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      },
      async updateGroupedReport() {
        let url = process.env.VUE_APP_URL_APP + '/b/admin/grouped-reports/' + this.formData.token

        try {
          let response = await this.$http.put(url, this.formData)
          this.feedback.show = true
          this.feedback.type = 'success'
          this.feedback.data = 'Relatório agrupado atualizado com sucesso. Redirecionando para a lista de relatórios...'
          setTimeout(() => {
            this.$router.push({ name: 'AdminGroupedReportList', params: { scrollTo: 'top' } })
          }, 4000)
        } catch (err) {
          console.log(err)
          this.feedback.show = true
          this.feedback.type = 'danger'
          this.feedback.data = err.body.message
        }
      },
      async createGroupedReport() {
        let url = process.env.VUE_APP_URL_APP + '/b/admin/grouped-reports'

        try {
          let response = await this.$http.post(url, this.formData)
          this.feedback.show = true
          this.feedback.type = 'success'
          this.feedback.data = 'Relatório agrupado criado com sucesso. Redirecionando para a lista de relatórios...'
          setTimeout(() => {
            this.$router.push({ name: 'AdminGroupedReportList', params: { scrollTo: 'top' } })
          }, 4000)
        } catch (err) {
          console.log(err)
          this.feedback.show = true
          this.feedback.type = 'danger'
          this.feedback.data = err.body.message
        }
      }
    },
  };
  </script>

  <style scoped>
  .navigation {
    margin-top: 20px;
  }
  button {
    margin-right: 10px;
    padding: 10px 15px;
    font-size: 14px;
  }
  </style>
